import React from 'react'
import { color, Icon, l } from '@manychat/manyui'

export const SuccessScreen = () => (
  <>
    <Icon.CheckCircle color={color.icon.success} size={48} />
    <h1 className="m-t-md">{l.translate('Sent')}</h1>
    <p className="m-t-xs">
      {l.translate('We will take into account your opinion and make our product better.')}
    </p>
  </>
)
